import { c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { prop, theme } from 'styled-tools';
import styled from './styled.js';
import use from './use.js';
import { createElement } from 'react';
import { string } from 'prop-types';
import { a as bgColorWithProps } from './chunk-1128464e.js';
import Box from './Box.js';
import { a as hoist } from './chunk-0cd02bff.js';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  font-size: 30px;\n  width: 1em;\n  height: 1em;\n  pointer-events: none;\n  background-color: transparent;\n\n  & .stroke {\n    fill: ", ";\n  }\n\n  & .fill {\n    fill: ", ";\n  }\n\n  [data-placement^=\"top\"] > & {\n    top: 100%;\n    transform: rotateZ(180deg);\n  }\n\n  [data-placement^=\"right\"] > & {\n    right: 100%;\n    transform: rotateZ(-90deg);\n  }\n\n  [data-placement^=\"bottom\"] > & {\n    bottom: 100%;\n    transform: rotateZ(360deg);\n  }\n\n  [data-placement^=\"left\"] > & {\n    left: 100%;\n    transform: rotateZ(90deg);\n  }\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PopoverArrowComponent = function PopoverArrowComponent(props) {
  return createElement(Box, props, createElement("svg", {
    viewBox: "0 0 30 30"
  }, createElement("path", {
    className: "stroke",
    d: "M23.7,27.1L17,19.9C16.5,19.3,15.8,19,15,19s-1.6,0.3-2.1,0.9l-6.6,7.2C5.3,28.1,3.4,29,2,29h26 C26.7,29,24.6,28.1,23.7,27.1z"
  }), createElement("path", {
    className: "fill",
    d: "M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z"
  })));
};

var PopoverArrow = styled(hoist(PopoverArrowComponent, Box))(_templateObject(), prop("strokeColor"), prop("fillColor", bgColorWithProps), theme("PopoverArrow")); // @ts-ignore

PopoverArrow.propTypes = {
  fillColor: string,
  strokeColor: string
};
PopoverArrow.defaultProps = {
  strokeColor: "transparent",
  opaque: true,
  palette: "white"
};
var PopoverArrow$1 = use(PopoverArrow, "div");

export { PopoverArrow$1 as a };
